/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import { Container, Button } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js';
import envisionLogo from '../assets/images/envision-logo-lg.png';
// import sidebarLogoLg from '../assets/images/daikin-sidebar-img.png';
import * as images from '../assets';
import './Sidebar.scss';

// Import Components
import VerticalLayout from './VerticalLayouts';
import { withBase } from '../utils/route.util';

function Sidebar({ layoutType }) {
  const location = useLocation();
  const path = location.pathname;

  const isHRDashboard = path.includes('/hr');

  useEffect(() => {
    const controller = new AbortController();
    const el = document.querySelector('.vertical-overlay');
    const handler = () =>
      document.body.classList.remove('vertical-sidebar-enable');

    el?.addEventListener('click', handler, { signal: controller.signal });

    return () => controller.abort();
  }, []);

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (
      document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover'
    ) {
      document.documentElement.setAttribute(
        'data-sidebar-size',
        'sm-hover-active',
      );
    } else if (
      document.documentElement.getAttribute('data-sidebar-size') ===
      'sm-hover-active'
    ) {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };

  const [sidebarMinimized, setSidebarMinimized] = useState(
    document.documentElement.getAttribute('data-sidebar-size') === 'sm',
  );

  const toggleSidebar = () => {
    const newSize = sidebarMinimized ? 'lg' : 'sm';
    document.documentElement.setAttribute('data-sidebar-size', newSize);
    setSidebarMinimized(!sidebarMinimized);
  };

  const getDashboardLink = () => {
    const { pathname } = window.location;
    if (pathname.includes('/hr')) {
      return withBase('/hr/dashboard');
    }
    return withBase('/dashboard');
  };

  return (
    <>
      <div
        className="navbar-menu navbar-envision"
        data-mode={isHRDashboard ? 'hr' : 'self'}
      >
        <div className="navbar-brand-box">
          <Link to={getDashboardLink()} className="logo logo-light">
            <span className="logo-sm">
              <img
                src={envisionLogo}
                alt="Sidebar Menu - Minimised"
                height="35"
              />
            </span>
            <span className="logo-lg">
              <img
                src={images.imagesSideMenuLg}
                alt="Sidebar Menu - Expanded"
                height="80"
                style={{ width: '100%', objectFit: 'cover' }}
              />
            </span>
          </Link>
          <Button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
            data-bs-toggle="button"
          >
            <i className="ri-record-circle-line" />
          </Button>
        </div>

        {layoutType === 'vertical' && (
          <>
            <SimpleBar id="scrollbar" className="sidebar-simplebar">
              <Container fluid className="h-100">
                <div id="two-column-menu" />
                <ul
                  className={`h-100 navbar-nav d-flex flex-column fw-semibold ${isHRDashboard ? 'justify-content-start' : 'justify-content-between'}`}
                  id="navbar-nav"
                  style={{
                    gap: isHRDashboard ? '10px' : '0px',
                  }}
                >
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>
            <div className="sidebar-background" />
          </>
        )}
        <button
          type="button"
          className="sidebar-toggle-btn"
          onClick={toggleSidebar}
          title="Toggle Sidebar"
          aria-label="Toggle Sidebar"
        >
          <Icon
            path={sidebarMinimized ? mdiChevronRight : mdiChevronLeft}
            size={0.7}
            color="#fff"
          />
        </button>
      </div>
      <div className="vertical-overlay" />
    </>
  );
}

export default Sidebar;
